<div class="container" >
    <div class="header">
      <div class="logo">
        <img src="assets/images/logo.svg" alt="Logo">
      </div>
      <h1>{{'LANDING_PAGE.CANCELETION_POLICIES'| translate}}</h1>
    </div>
   
    <div *ngIf="pdfSrc" class="pdf-container">
      <pdf-viewer 
        [src]="pdfSrc"
        [render-text]="true"
        [original-size]="true"
        class="pdf-viewer">
      </pdf-viewer>
    </div>
  </div>
  